/* unplugin-vue-components disabled */import { render } from "./guideBottom.vue?vue&type=template&id=d59cc520&scoped=true"
import script from "./guideBottom.vue?vue&type=script&lang=js"
export * from "./guideBottom.vue?vue&type=script&lang=js"

import "./guideBottom.vue?vue&type=style&index=0&id=d59cc520&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d59cc520"]])

export default __exports__